const messages = {
  title: "Willkommen bei BRIDGESTONE <span class='text-danger'>PLUS</span>",
  description:
    "Melden Sie sich mit Ihrer E-Mail-Adresse und Ihrem Passwort an.<br/><b>Sind Sie neu hier?</b><br/>Erstellen Sie dann zunächst Ihr neues Benutzerkonto über die Funktion REGISTRIEREN.<br/>Sie werden dann automatisch eingeloggt.",
  info: "",
  buttons: {
    action: "Anmelden / Registrieren",
    back: "Zurück zur Anmeldung",
    changeLanguage: "Sprache ändern",
    start: "Starten",
  },
  languageSelect: {
    label: "Sprachauswahl",
    description: "Bitte wählen Sie eine Sprache ",
  },
};

export default {
  messages,
};
